import { z } from 'zod'

import { FEEDBACK_MOOD_VALUES, FeedbackTopic } from '../consts'
import type { FeedbackMoodValue } from '../consts/feedback-mood-values.const'

const FEEDBACK_TOPIC_VALUES = Object.values(FeedbackTopic) as [
  (typeof FeedbackTopic)[keyof typeof FeedbackTopic],
  ...(typeof FeedbackTopic)[keyof typeof FeedbackTopic][],
]

const feedbackMoodSchema = (message: string) =>
  z.union(
    FEEDBACK_MOOD_VALUES.map((value) => z.literal(value)) as [
      z.ZodLiteral<FeedbackMoodValue>,
      z.ZodLiteral<FeedbackMoodValue>,
      z.ZodLiteral<FeedbackMoodValue>,
      z.ZodLiteral<FeedbackMoodValue>,
      z.ZodLiteral<FeedbackMoodValue>,
      z.ZodLiteral<FeedbackMoodValue>,
    ],
    { error: message }
  )

export const createFeedbackSchema = (t: (key: string) => string) =>
  z.object({
    topic: z.enum(FEEDBACK_TOPIC_VALUES, {
      message: t('validation.topicRequired'),
    }),
    message: z
      .string()
      .min(1, t('validation.messageRequired'))
      .min(10, t('validation.messageMinLength'))
      .max(1000, t('validation.messageMaxLength')),
    mood: feedbackMoodSchema(t('validation.moodRequired')),
  })

export type CreateFeedbackFormData = z.infer<ReturnType<typeof createFeedbackSchema>>
